import { useEffect, useState } from "react";
import { imageUrlToBase64 } from "src/utils";
import { PrintClient, ScenarioSettings } from "src/types";
import config from "src/services/config";

const Header = ({
  client,
  scenario,
  page,
  visible,
}: {
  client: PrintClient;
  scenario: ScenarioSettings;
  page: string;
  visible?: boolean;
}) => {
  const logoUrl = client?.userdata?.logo
    ? `${config.PRINT_API_URL}logo?logo=${client?.userdata?.logo}`
    : `${config.APP_URL}/logo.png`;
  const [logoData, setLogoData] = useState("");
  useEffect(() => {
    imageUrlToBase64(logoUrl).then((data) => {
      setLogoData(data);
    });
  }, [logoUrl]);
  return (
    <div className={!visible ? "hidden" : ""}>
      <div id="print-header">
        <div
          style={{
            width: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            fontSize: "12px",
            color: "black",
            // backgroundColor: "#f0f0f0",
            display: "flex",
            justifyContent: "space-between",
            WebkitPrintColorAdjust: "exact",
          }}
        >
          <div
            className="flex justify-between border-b border-[#f0f]"
            style={{
              borderBottom: "1px solid #aaa",
              width: "calc(100% - 50px)",
              padding: "10px 20px",
              paddingTop: "20px",
              // color: "black",
              // backgroundColor: "#f0f0f0",
              color: "#444",
              display: "flex",
              justifyContent: "space-between",
              alignContent: "center",
              WebkitPrintColorAdjust: "exact",
              marginLeft: 10,
              marginRight: 10,
            }}
          >
            <div>{scenario.name}</div>
            <div
              style={{
                display: "flex",
                gap: "10px",
                fontWeight: "600",
                fontSize: "15px",
                color: "black",
              }}
            >
              {page}
            </div>
            <div>
              <img
                src={`${logoData}`}
                alt="logo"
                style={{
                  height: "25px",
                  width: "auto",
                  maxHeight: "20px",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
